import { useCallback } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { useSendEventLog } from '@/hooks'

type ErrorLog = {
  message: string;
  error?: any;
}

function useErrorLogs() {
  const sendEventLog = useSendEventLog()

  return useCallback((options: ErrorLog) => {
    const { message, error } = options

    sendEventLog({
      actionId: message,
      custom: { error },
      isSkip: true,
    })
    datadogRum.addError(error, {
      error: { ...error, message },
    })
  }, [sendEventLog])
}

export { useErrorLogs }
